import { useMemo } from "react";

import { LanguageCode, supportedLanguages } from "@/utils/i18n";
import { useLanguageCodeWithDefault, useSessionLanguageCode } from "@/utils/language";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export function LanguagePicker({
    onSelectLanguage,
}: {
    onSelectLanguage: (lang: LanguageCode) => void;
}) {
    const languageCode = useLanguageCodeWithDefault();
    const selectedLanguage = useMemo(
        () => supportedLanguages.find(lang => lang.code === languageCode),
        [languageCode]
    );

    return (
        <Select onValueChange={onSelectLanguage} value={languageCode ?? undefined}>
            <SelectTrigger className="w-[180px]">
                <SelectValue className="uppercase" placeholder="Select language">
                    {selectedLanguage?.name}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {supportedLanguages.map(language => (
                    <SelectItem key={language.code} value={language.code}>
                        {language.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

export function SessionLanguagePicker() {
    const [_languageCode, setLanguageCode] = useSessionLanguageCode();
    return <LanguagePicker onSelectLanguage={setLanguageCode} />;
}
